<template>
    <div class="box-middle-takePage">
        <div class="takepage-cnt">
            <!-- 未登录 -->
            <div class="logged">
                <div class="haslogged " v-if="islogin">
                    <div class="btn-list  d-flex align-items-center">
                        <div class="prize mr-8 cursor" @click="prizeModel"></div>
                        <div class="rule mr-8 cursor" @click="ruleModel"></div>
                    </div>
                </div>
                <div class="notlogged cursor" @click="showLogin()" v-else></div>
            </div>
            <!-- 活动 -->
            <div class="tt-list">
                <div class="tt1">
                    <div class="title"></div>
                    <div class="cnt">
                        <div class="img-list ">
                            <div class="position-relative" v-for="(item, index) in takesList" :key="index"
                                v-show="index < 3">

                                <img class="img-size filter-gray"
                                    :src="require(`../../../assets/img/m4/mission${item.id}.png`)" alt="" srcset="">
                                <div class="clear-icon d-block"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tt2">
                    <div class="title"></div>
                    <div class="cnt">
                        <div class="img-list ">
                            <div class="position-relative" v-for="(item, index) in takesList" :key="index"
                                v-show="index >= 3">
                                <img class="img-size filter-gray"
                                    :src="require(`../../../assets/img/m4/mission${item.id}.png`)" alt="" srcset="">
                                <div class="clear-icon d-block"></div>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="tt3">
                    <div class="title"></div>
                    <div class="cnt">
                        <div class="img-list ">
                            <img src="../../../assets/img/m4/tt3-hd.png" alt="" class="filter-gray">
                            <div class="clear-icon tt3-clear-icon d-block"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// 活动登录, "islogin"

export default {
    props: ["onNext", 'islogin'],

    data() {
        return {

            mouseFlag: this.onNext,

            takesList: [
                {
                    id: "1",
                    url: ''
                },
                {
                    id: "2",
                    url: 'https://game.naver.com/lounge/zero9'
                },
                {
                    id: "3",
                    url: ''
                },
                {
                    id: "4",
                    url: 'https://www.naver.com/'
                },
                {
                    id: "5",
                    url: 'https://game.naver.com/lounge/zero9'
                },
            ],
        }
    },
    created() {

    },
    mounted() {

    },
    watch: {
    },
    methods: {

        // 显示活动登录弹出框
        showLogin() {
            this.$emit('showTaskLoginModel', true)
        },

        ruleModel() {
            this.$emit('showRoleModel', true, 2)
        },
        //  我的奖品
        prizeModel() {
            this.$emit('showPrizeModel', true, 2)
        },
    }
}
</script>

<style lang="scss">
.takepage-cnt {
    position: relative;
    width: 100%;
    height: 100%;
}

.box-middle-takePage {
    .logged {

        .notlogged {
            background: url("../../../assets/img/m4/notlogged.png") no-repeat top;
            background-size: 100% 100%;
            width: 281px;
            height: 53px;
            margin: 24px auto 16px auto;
        }

        .haslogged {
            margin: 24px 0;
            display: flex;
            align-items: center;
            justify-content: center;

            .btn-list {
                margin-top: 18px;

                .prize {
                    background: url("../../../assets/img/m4/lottery/prize.png") no-repeat top;
                    background-size: 100% 100%;
                    width: 296px;
                    height: 67px;
                }

                .rule {
                    background: url("../../../assets/img/m4/lottery/rule.png") no-repeat top;
                    background-size: 100% 100%;
                    width: 296px;
                    height: 67px;
                }

                .back1 {
                    background: url("../../../assets/img/m4/lottery/back.png") no-repeat top;
                    background-size: 100% 100%;
                    width: 244px;
                    height: 60px;
                }
            }

            
        }
    }

    .img-list {
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        bottom: -22px;
        width: 100%;
    }

    .tt-list {
        position: absolute;
        right: 0;
        //    margin-top: 24px;

    }

    .tt1 {
        .title {
            background: url("../../../assets/img/m4/tt1.png") no-repeat top;
            background-size: cover;
            width: 412px;
            height: 28px;
            margin: 0 auto;
        }

        .cnt {
            background: url("../../../assets/img/m4/hd-bg.png") no-repeat top;
            background-size: cover;
            width: 866px;
            height: 127px;
            margin-top: 20px;
            position: relative;

            img {
                width: 215px;
                height: 131px;
                display: block;

                margin-right: 12px;
            }

        }
    }


    .tt2 {
        margin-top: 45px;

        .title {
            background: url("../../../assets/img/m4/tt2.png") no-repeat top;
            background-size: cover;
            width: 430px;
            height: 28px;
            margin: 0 auto;
        }

        .cnt {
            background: url("../../../assets/img/m4/hd-bg.png") no-repeat top;
            background-size: cover;
            width: 866px;
            height: 127px;
            margin-top: 20px;
            position: relative;

            img {
                width: 300px;
                height: 132px;
                display: block;

                margin-right: 12px;
            }

        }
    }

    .tt3 {
        margin-top: 45px;

        .title {
            background: url("../../../assets/img/m4/tt3.png") no-repeat top;
            background-size: cover;
            width: 492px;
            height: 28px;
            margin: 0 auto;
        }

        .cnt {
            background: url("../../../assets/img/m4/hd-3-bg.png") no-repeat top;
            background-size: cover;
            width: 866px;
            height: 166px;
            margin-top: 20px;
            position: relative;

            img {
                width: 738px;
                height: 186px;
            }


        }
    }

    .filter-gray {
        filter: grayscale(100%);
    }

    .clear-icon {
        background: url("../../../assets/img/m4/clear.png") no-repeat top;
        background-size: cover;
        width: 136px;
        height: 70px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .tt3-clear-icon {
        left: 240px;
    }
    .d-block {
        display: block !important;
    }

    .d-none {
        display: none !important;
    }



}

@media screen and (min-width: 2560px) and (max-width: 3440px) {
    .box-middle-takePage {
        .tt-list {
            right: 80px !important;
        }

        .cnt {
            width: 736px !important;
            height: 108px !important;
            margin-top: 12px !important;

        }

        .notlogged {
            width: 224px !important;
            height: 42px !important;
            margin: 0 auto 16px auto !important;

        }

        .haslogged {
            margin:  12px 0 !important;
            .btn-list {
                margin-top: 0 !important;
            }
        }

        .tt1 {
            .title {
                width: 350px !important;
                height: 24px !important;
            }

            img {
                width: 182px !important;
                height: 111px !important;
            }
        }

        .tt2 {
            .title {
                width: 366px !important;
                height: 24px !important;
            }

            img {
                width: 255px !important;
                height: 112px !important;
            }
        }

        .tt3 {
            margin-top: 24px !important;

            .title {
                width: 418px !important;
                height: 24px !important;
            }

            .cnt {
                width: 736px !important;
                height: 141px !important;
            }

            img {
                width: 627px !important;
                height: 158px !important;
            }
        }

    }
}
</style>


// WEBPACK FOOTER //
// src/components/publicComponents/eventComponents/takePage.vue